import { createAction, props } from '@ngrx/store';
import { LookupDataState } from '../lookup-data.reducer';

export const loadLookupData = createAction('[Lookups API] Load Lookup Data');

export const updateLookupData = createAction(
  '[Lookups API] Update Lookup Data',
  props<LookupDataState>()
);
